//
// Generated class EventProgram
//

/// <reference path="EventProgram_ManagedObject.ts" />

class EventProgram extends EventProgram_ManagedObject
{

}
